export default class Tracking {
  bindTrackers () {
    var trackerElements = this._getTrackingElements() || []
    if (trackerElements.length < 1) {
      return false
    }

    trackerElements.forEach((el) => {
      el.addEventListener('click', (evt) => this._track(evt))
    })
  }

  _track (evt) {
    var el = evt.target
    var data = el.dataset

    if (data.eventDetails) {
      mixpanel.track(data.eventName, JSON.parse(data.eventDetails))
    } else {
      mixpanel.track(data.eventName)
    }
  }

  _getTrackingElements () {
    var trackingElements = document.querySelectorAll('[data-tracking="true"]')
    return trackingElements
  }
}
